import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useDebouncedValue } from '@mantine/hooks';

const useStateWithDebounce = <T = unknown>(
  initialState: T,
  {
    wait = 200,
    queryParamKey,
  }: {
    wait?: number;
    queryParamKey?: string;
  } = {},
): [T, React.Dispatch<React.SetStateAction<T>>, T] => {
  const [, setSearchParams] = useSearchParams();

  const [state, setState] = useState(initialState);

  const [debouncedValue] = useDebouncedValue(state, wait, { leading: true });

  useEffect(() => {
    if (
      queryParamKey &&
      (typeof debouncedValue === 'string' || typeof debouncedValue === 'number')
    ) {
      setSearchParams((prev) => {
        prev.set(queryParamKey, debouncedValue.toString());
        return prev;
      });
    }
  }, [debouncedValue, queryParamKey]);

  return [state, setState, debouncedValue];
};

export default useStateWithDebounce;
